import React from 'react'
import { withTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';

import './Footer.scss'

import brandLogo from '../../images/logo_footer.gif';
import accessibilityLogo from '../../images/wcag2.1AA.png'

export default withTranslation()(function Navbar({t, i18n}) {

    return (
        <Box className="footer">
            <Box className="footerWrapper">
                <Box className="linkList">
                    <a 
                        href={`https://www.gov.hk/${i18n.language}/about/aboutus.htm`} 
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('common.footer.abtGov')}
                    </a>
                    <a 
                        href={`https://www.gov.hk/${i18n.language}/about/copyright.htm`} 
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('common.footer.copyright')}
                    </a>
                    <a 
                        href={`https://www.gov.hk/${i18n.language}/about/privacy.htm`} 
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('common.footer.privacy')}
                    </a>
                    <a 
                        href={`https://www.gov.hk/${i18n.language}/about/copyright.htm#disclaimer`} 
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('common.footer.disclaimer')}
                    </a>
                    <a 
                        href="https://www.w3.org/WAI/WCAG2AA-Conformance"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img style={{height: "26px"}} src={accessibilityLogo} alt="web content accessibility"/>
                    </a>
                </Box>
                <Box className="brandLogo">
                    <a 
                        href={`https://www.brandhk.gov.hk/html/${i18n.language}/`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={brandLogo} alt="Brand Hong Kong" />
                    </a>
                </Box>
            </Box>
        </Box>
    )
})
